<template>
  <div id="container"></div>
</template>

<script>
// window.onload = function () {
//   function init() {
//     var myLatlng = new qq.maps.LatLng(-34.397, 150.644);
//     var myOptions = {
//       zoom: 10,
//       center: myLatlng,
//       mapTypeId: qq.maps.MapTypeId.ROADMAP,
//       // 设置地图样式
//     };
//     var map = new qq.maps.Map(document.getElementById("container"), myOptions);
//   }
//   init();
// };

//
export default {
  name: "location-name",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var center = new TMap.LatLng(39.984104, 116.307503);
      //初始化地图
      var map = new TMap.Map("container", {
        rotation: 20, //设置地图旋转角度
        pitch: 30, //设置俯仰角度（0~45）
        zoom: 12, //设置地图缩放级别
        center: center, //设置地图中心点坐标
      });
    },
  },
};
</script>

<style>
#container {
  width: auto;
  height: 300px;
}
</style>